/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringCriteriaForMarketingAirlineOutput
 */
export interface StringCriteriaForMarketingAirlineOutput {
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaForMarketingAirlineOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringCriteriaForMarketingAirlineOutput
     */
    effective?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StringCriteriaForMarketingAirlineOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaForMarketingAirlineOutput
     */
    value?: string | null;
}

export function StringCriteriaForMarketingAirlineOutputFromJSON(json: any): StringCriteriaForMarketingAirlineOutput {
    return StringCriteriaForMarketingAirlineOutputFromJSONTyped(json, false);
}

export function StringCriteriaForMarketingAirlineOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringCriteriaForMarketingAirlineOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function StringCriteriaForMarketingAirlineOutputToJSON(value?: StringCriteriaForMarketingAirlineOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'effective': value.effective,
        'exclude': value.exclude,
        'value': value.value,
    };
}


